import { postForm, postJson, get } from "./request.js";
import { signActionTime } from "./headerToken.js";
import httpBaseConfig from "../baseConfig/config";

const reqIp1 = httpBaseConfig.casinoApi();
const betApi = httpBaseConfig.betApi();

// 公共查询充值是否成功接口
export function getDepositResult(params) {
  return get({
    url: `${reqIp1}/api/payments/depositResult`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

// 查询乌干达充值是否成功接口
export function getUgDepositResult() {
  return get({
    url: `${reqIp1}/api/payments/depositResultNew`,
    headers: signActionTime("get", {})
  })
}

//查询提现是否成功
export function getWithdrawResult() {
  return postJson({
    url: `${reqIp1}/api/payments/withdraw/status`,
    params: {},
    headers: signActionTime("postJson", {})
  })
}

export function getKeDepositResult(params) {
  return get({
    url: `${reqIp1}/api/payments/mpesa/checkPayStatus`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

//获取成功页banner接口
export function getBanner(params) {
  return get({
    url: `${reqIp1}/api/payments/common/jumpUrls`,
    params: {
      ...params
    },
    headers: signActionTime("get", {params})
  });
}

//获取金刚位
export function getHomeMenu(params) {
  return get({
    url: `${betApi}/api/bet/system/depositPage/homeMenu`,
    params: {
      ...params
    },
    headers: signActionTime("get", {params})
  });
}

//跳转第三方游戏
export function getThirdGameData(params) {
  return get({
      url: `${reqIp1}/api/partner/user/getOneTouchGameUrl`,
      params: { ...params },
      headers: signActionTime('get', params),
  })
}

// 获取对应国家的支付限制金额
export function payRange(params) {
  return get({
    url: `${reqIp1}/api/payments/common/payRange`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

// 肯尼亚相关接口

// interswithch 充值方式切换的参考金额
export function switchReferenceValue(params) {
  return postJson({
    url: reqIp1 + "/api/payments/interswitchCard/switchReferenceValue",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 肯尼亚充值失败是否显示右上角Deposit failed接口
export function getDepositFailed(params) {
  return get({
    url: `${reqIp1}/api/payments/mpesa/mpesaBillInfo`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

// 肯尼亚补贴
export function depositRangeBonus(params) {
  return postJson({
    url: reqIp1 + "/api/payments/common/depositRangeBonus",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 作废
export function extraSubsidy(params) {
  return postJson({
    url: reqIp1 + "/api/payments/common/extraPresentation",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/*
 * 获取用户信息
 * */
export function getApiUserInfo(params) {
  return postForm({
    url: "/api/bet/user/userInfo",
    params: {
      ...params
    },
    headers: signActionTime("postForm", params)
  });
}

/*
 * Mpesa支付
 * */
export function MpesaPay(params) {
  return postJson({
    url: reqIp1 + "/api/payments/mpesa/onlinePay",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// interswitch 获取用户信息
export function getCustomInfo(params) {
  return get({
    url: `${reqIp1}/api/payments/interswitchCard/getCustomInfo`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}
//检验ugKYC
export function checkNinInfo(params) {
  return postJson({
    url: `${reqIp1}/api/center/checkNinInfo`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

//提交ugKYC
export function submitNinInfo(params) {
  return postJson({
    url: `${reqIp1}/api/center/user/updateNin`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// interswitchCard 存款
export function interswitchDeposit(params) {
  return postJson({
    url: `${reqIp1}/api/payments/interswitchCard/deposit`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// Manual Reconciliation
export function reconciliation(params) {
  return postJson({
    url: `${reqIp1}/api/payments/mpesa/deposit/confirm`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 加纳相关接口
export function defaultType(params) {
  return postJson({
    url: reqIp1 + "/api/payments/defaultWithdrawtype",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

//hubtel支付
export function HubtelPay(params) {
  return postJson({
    url: reqIp1 + "/api/payments/hubtel/deposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 加纳获取 充值、提现 方式列表
export function ghPayList (params) {
  return postJson({
    url: reqIp1 + "/api/payments/payList/deposit/gh",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  })
}


// 乌干达相关接口
export function yoPay(params) {
  return postJson({
    url: reqIp1 + "/api/payments/yo/deposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/**
 *{
	 "type": "deposit"     固定值 充值传递deposit   提现传递withdraw
	}
 * @param {*} params 
 * @returns 
 */
export function checkUgMtn(params) {
  return postJson({
    url: reqIp1 + "/api/payments/mtn/isActivity",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function ugMtnPay(params) {
  return postJson({
    url: reqIp1 + "/api/payments/mtn/deposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function ugAirtelPay(params) {
  return postJson({
    url: reqIp1 + "/api/payments/airtelbackend/deposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function ugMtnWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/mtn/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function ugAirtelWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/airtelbackend/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 尼日利亚相关接口
/* 首次充值 */
export function ngFirstDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/create/order",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
//调取h5收银台
export function ngDepositH5(params) {
  return postJson({
    url: reqIp1 + "/api/payments/palm/v2/deposit/h5",
    params:{...params},
    headers:signActionTime("postJson", params)
  })
}
//bankTransfer新的支付方式
export function ngBankTransfer(params) {
  return postJson({
    url: reqIp1 + "/api/payments/palm/v2/deposit/bankTransfer",
    params:{...params},
    headers:signActionTime("postJson", params)
  })
}
/* 尼日利亚充值获取充值方式列表*/
export function ngDepositList(params) {
  return postJson({
    // url: reqIp1 + "/api/payments/paystack/deposit/list",
    url: reqIp1 + "/api/payments/deposit/ng/list",
    headers: signActionTime("postJson", params),
    params: {
      ...params
    }
  });
}


/* 乌干达充值 */
export function ugDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/deposit/Ug",
    headers: signActionTime("postJson", params),
    params: {
      ...params
    }
  });
}

//乌干达KYC开关
export function ninSwitch(){
  return get({
      url: `${reqIp1}/api/center/nin/switch?country=ug`,
  })
}

/* 首次充值inline模式 */
export function futterFirstDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/flutter/create/order",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 获取充值金额列表
export function depositLevelList(params) {
  return postJson({
    url: reqIp1 + "/api/payments/depositLevel",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

// 获取充值简介列表
export function depositIntroList(params) {
  return postJson({
    url: reqIp1 + "/api/payments/depositIntroduce",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
//获取新的充值金额列表
export function listByCountry(params) {
  return get({
    url: reqIp1 + "/api/payments/depositConfig/listByCountry",
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

export function depositeUgPaymentStatus(params) {
  return postJson({
    url: reqIp1 + "/api/payments/airtelbackend/paymentStatus",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 获取银行列表的接口*/
export function getBankList(params) {
  return get({
    url: `${reqIp1}/api/payments/paystack/deposit/banks`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

/* opay充值 */
export function ngOpayDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/opay/deposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/*PalmPay充值 */
export function PalmPay(params) {
  return postJson({
    url: reqIp1 + "/api/payments/palm/deposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* withBank信息 */
export function depositWithBankTransfer(params) {
  return postJson({
    url: reqIp1 + "/api/payments/flutter/depositWithBankTransfer",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
/* 验证USSD充值成功接口*/
export function ussdCheck(params) {
  return get({
    url: `${reqIp1}/api/payments/paystack/check`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

/* 获取银行历史列表的接口*/
export function getHistoryBankList(params) {
  return get({
    url: `${reqIp1}/api/payments/paystack/deposit/userBanks`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

/* 删除充值卡 */
export function ngDepositCardDel(params) {
  return get({
    url: reqIp1 + "/api/payments/paystack/delUserAuth",
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

/* ng充值- 获取paystack和fluttertoken集合 */
export function ngGetDepositTokens(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/userDepositTokenList",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 银行充值接口 */
export function payBank(params) {
  return postJson({
    url: `${reqIp1}/api/payments/paystack/bankDeposit`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
/* 尼日首次充值次数过多 */
export function ngDepositMoreTimes(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/failedDepositTimes",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 判断是否有提示语 */
export function preDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/preDeposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
/* 尼日提现获取姓名 */
export function ngWithdrawGetNames(params) {
  return postJson({
    url: reqIp1 + "/api/payments/preWithdraw",
    headers: signActionTime("postJson", params)
  });
}
export function cardInsert(params) {
  return postJson({
    url: `${reqIp1}/api/payments/paystack/cardDeposit`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function checkPin(params) {
  return postJson({
    url: `${reqIp1}/api/payments/paystack/submit`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 获取充值USSD列表*/
export function getUssdList() {
  return get({
    url: `${reqIp1}/api/payments/paystack/deposit/ussds`,
    headers: signActionTime("postForm")
  });
}

/* 获取充值USSD详情*/
export function getUssdDetails(params) {
  return postJson({
    url: `${reqIp1}/api/payments/paystack/newUssd`,
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 通过auth_code充值 -- 二次充值 */
export function ngNextDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/depositUseAuth",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 尼日充值添加姓名 */
export function ngDepositAddName(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/deposit/depositUserName",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function delUserBank(params) {
  return get({
    url: `${reqIp1}/api/payments/paystack/deposit/delUserBank`,
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

/* 提现初始化判断 */
export function initWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/defaultWithdrawtype",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/*
 * 手续费验证
 * */
export function CheckWithdrawAmount(params) {
  return get({
    url: reqIp1 + "/api/payments/checkWithdrawAmount",
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

/*
 * Mpesa提现
 * */
export function MpesaWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/mpesa/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 肯尼亚airtel提现接口 */
export function airtelWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/airtel/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/*
 * YoPayments提现
 * */
export function YoPaymentsWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/yo/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* ng获取 - 提现获取提现额度 */
export function ngGetWithdrawFreeAmount(params) {
  return get({
    url: reqIp1 + "/api/payments/freeWithdrawInfo",
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}
/* ng提现 - 获取修正金额 */
export function ngGetWithdrawModifyAmount(params) {
  return get({
    url: reqIp1 + "/api/payments/checkWithdrawAmount",
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

// 加纳提现
export function ghWithDraw(params) {
  return postJson({
    url: `${reqIp1}/api/payments/hubtel/withdraw`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}
// 加纳提现手续费
export function ghWithdrawFee(params) {
  return postJson({
    url: `${reqIp1}/api/payments/hubtel/withdrawFee`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}

/* 充值提现提示信息接口 */
export function remindTexts(params) {
  return postJson({
    url: "/message/list",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 尼日提现姓名长度获取 */
export function ngWithdrawGetNameLen(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/bankAccountName",
    headers: signActionTime("postJson", params),
    params: {
      ...params
    }
  });
}

/* 尼日提现姓名模糊匹配接口 */
export function ngWithdrawNameReg(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/newValidateBankAccount",
    headers: signActionTime("postJson", params),
    params: {
      ...params
    }
  });
}
/* 尼日提现姓名认证接口 */
export function ngWithdrawNameVerify(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/validateBankAccountName",
    headers: signActionTime("postJson", params),
    params: {
      ...params
    }
  });
}

// opay提现资格检查
export function ngOpayWithdrawCheckUser(params) {
  return postJson({
    url: `${reqIp1}/api/payments/opay/withdraw/check`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}

// plampay 资格检查
export function ngPamlpayWithdrawCheckUser(params) {
  return postJson({
    url: `${reqIp1}/api/payments/palm/check/history`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}

// plampay 提现操作
export function ngPamlpayWithdraw(params) {
  return postJson({
    url: `${reqIp1}/api/payments/palm/withdraw`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}

// opay提现费率
export function ngOpayWithdrawFee(params) {
  return postJson({
    url: `${reqIp1}/api/payments/opay/withdraw/fee`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}

// opay提现
export function ngOpayWithdraw(params) {
  return postJson({
    url: `${reqIp1}/api/payments/opay/withdraw`,
    params: params,
    headers: signActionTime("postJson", params)
  });
}

/* 获取银行列表 */
export function ngWithdrawBankList(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/banks",
    headers: signActionTime("postJson", params)
  });
}

/*
 * 验证码获取接口
 * */
export function getRandCode(params) {
  return postJson({
    url: reqIp1 + "/api/payments/sms/code",
    params: {
      ...params
    }
  });
}

/*
 * 语音验证的接口
 * */
export function getPhoneVerification(params) {
  return postJson({
    url: reqIp1 + "/api/payments/sms/code/voice",
    params: {
      ...params
    }
  });
}

/*
 * 语音验证的接口
 * */
export function callPhone(params) {
  return postJson({
    url: reqIp1 + "/api/payments/sms/voice/call",
    params: {
      ...params
    }
  });
}
/*
 * 确认验证码
 * */
export function checkRandCode(params) {
  return postJson({
    url: reqIp1 + "/api/center/checkCode",
    params: {
      ...params
    }
  });
}

/* 验证银行信息 */
export function ngCheckBankInfo(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/validateBankAccount",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
/* 提现CardList */
export function ngWithdrawCardList(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/userRecipient",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 首次提现 */
export function ngFistWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

//获取个人信息
export function setUserInfo(params) {
  return postJson({
    url: reqIp1 + "/api/center/user/updateUserInfo",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
// 存用户得信息infomation
export function userInfomation(params) {
  return postJson({
    url: reqIp1 + "/api/payments/information",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
// 尼日利亚存储KYC信息
export function ngUserInfomation(params) {
  return postJson({
    url: reqIp1 + "/api/payments/ng/information",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
//api/payments/ng/informationnew
export function ngUserInfomationNew(params) {
  return postJson({
    url: reqIp1 + "/api/payments/ng/informationnew",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}
// 存用户得信息infomation
export function userInfoIsNew(params) {
  return get({
    url: reqIp1 + "/api/payments/isNew",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/* 提现Card删除 */
export function ngWithdrawCardDel(params) {
  return get({
    url: reqIp1 + "/api/payments/paystack/delUserRecipient",
    params: {
      ...params
    },
    headers: signActionTime("get", params)
  });
}

// 充值记录列表
export function getPaymentLog(params) {
  return get({
    url: reqIp1 + "/api/payments/log/recentDeposit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

export function reportEventAction(params) {
  return postJson({
    url: "/api/bet/bang/actionRecord",
    params: {
      ...params
    }
  });
}
// 获取加纳盈利税
export function getGhWithdrawTax (params) {
  return get({
    url: reqIp1 + "/api/payments/hubtel/withdrawTax",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  })
}
// 获取尼日利亚可提现余额
export function getWithdrawmaxamount(params) {
  return postJson({
    url: reqIp1 + "/api/payments/paystack/withdrawmaxamount",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  })
}

// 尼日利亚monnify充值
export function ngMonnifyDeposit(params) {
  return postJson({
    url: reqIp1 + '/api/payments/monnify/deposit',
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  })
}
export function getFirstBonusStatus(params) {
  return get({
    url: `${reqIp1}/api/center/bonus/getUserRechargeActivityPara`,
    params,
    headers: signActionTime("get", params)
  })

}

export function getDepositTips(params) {
  return get({
    url: `${reqIp1}/api/payments/common/getDepositTips`,
    params,
    headers: signActionTime("get", params)
  })

}

export function ngActivity() {
  return get({
    url: `${reqIp1}/api/payments/deposit/ng/activity`,
    headers: signActionTime("get")
  })
}

// 二次充值默认选择充值方式
export function getRecentPay () {
  return postJson({
    url: reqIp1 + '/api/payments/recentPayType',
    headers: signActionTime("postJson")
  })
}
//是否需要校验bvn
export function getNgisNeedBvn(params) {
  return postJson({
    url: reqIp1 + "/api/payments/ng/isNeedBvn",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  })
}


// 乌干达支付方式列表获取
export function getRecentPayUg () {
  return postJson({
    url: reqIp1 + '/api/payments/payList/deposit/ug',
    headers: signActionTime("postJson")
  })
}

// 乌干达提现方式获取
export function getRecentWithdrawUg () {
  return postJson({
    url: reqIp1 + '/api/payments/payList/withdraw/ug',
    headers: signActionTime("postJson")
  })
}

// 乌干达提现接口
export function ugWithdraw (params) {
  return postJson({
    url: reqIp1 + '/api/payments/withdraw/ug',
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  })
}
//   url: "/api/bet/user/userInfo",
export function getDepositGiftStatus(params) {
  return get({
    url: `/api/bet/activityCoupon/getUserDepositAward`,
    params,
    headers: signActionTime("get", params)
  })

}


// 肯尼亚充值默认选择充值方式
export function getRecentPayKe () {
  return postJson({
    url: reqIp1 + '/api/payments/payList/deposit/ke',
    headers: signActionTime("postJson")
  })
}

export function getKePayType (params) {
  return postJson({
    url: reqIp1 + `/api/payments/pay/method?country=${params.country}&type=${params.type}`,
    params,
    headers: signActionTime("postJson",params)
  })
}


// 坦桑尼亚支付方式列表获取
export function getRecentPayTz () {
  return postJson({
    url: reqIp1 + '/api/payments/payList/deposit/tz',
    headers: signActionTime("postJson")
  })
}

/**
 * @description: 坦桑尼亚 fasthub充值
 * @param {Object} { amount: number, phoneNumber: string }
 */
export function tzFasthubDeposit(params) {
  return postJson({
    url: reqIp1 + "/api/payments/fasthub/depositDebit",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

/**
 * @description: 坦桑尼亚 fasthub提现
 * @param {Object} { amount: number, phoneNumber: string }
 */
export function tzFasthubWithdraw(params) {
  return postJson({
    url: reqIp1 + "/api/payments/fasthub/withdraw",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}


// 肯尼亚vip用户判断
export function isVipUser(params) {
  return postJson({
    url: reqIp1 + "/api/payments/deposit/subsidyConfig",
    params: {
      ...params
    },
    headers: signActionTime("postJson", params)
  });
}

//获取开关状态
export function getTransferStatus(params) {
  return get({
    url: reqIp1 + `/api/center/diamond/transferStatus`,
    params,
    headers: signActionTime("get", params)
  })
}

//改变开关状态
export function changeTransferStatus(params) {
  return get({
    url: reqIp1 + `/api/center/diamond/updateTransferStatus`,
    params,
    headers: signActionTime("get", params)
  })
}

//获取最近一笔订单
export function getOrdersHistory() {
  return get({
    url: reqIp1 + `/api/center/orders/history`,
    headers: signActionTime("get", {})
  })
}

export function getTaxKe () {
  return get({
    url: reqIp1 + '/api/payments/tax/config/ke',
    headers: signActionTime("postJson")
  })
}

//获取大额充值规则文案
export function getListSpecByCountry(params) {
  return get({
    url: reqIp1 + `/api/payments/depositConfig/listSpecByCountry`,
    params,
    headers: signActionTime("get", params)
  })
}

export function getListDepositBonus (params) {
  return get({
    url: '/api/bet/depositActivity/listDepositBonus',
    params,
    headers: signActionTime("get",params)
  })
}
//查询充值税
export function checkDepositeTax (params) {
  return get({
    url: reqIp1 + '/api/payments/depositConfig/checkTax',
    params,
    headers: signActionTime("get",params)
  })
}

// 获取订单号
export function getorderNo (params) {
  return postJson({
    url:reqIp1+ '/api/payments/mpesa/onlinePay/minimpesa',
    params,
    headers: signActionTime("get",params)
  })
}
//查询充值税
export function getDepositeTaxText (params) {
  return get({
    url: reqIp1 + '/api/payments/tax/rule/ke/deposit',
    params,
    headers: signActionTime("get",params)
  })
}
// api/payments/tax/rule/ke/
export function getWithdrawTaxText (params) {
  return get({
    url: reqIp1 + '/api/payments/tax/rule/ke/withdraw',
    params,
    headers: signActionTime("get",params)
  })
}



// WEBPACK FOOTER //
// ./src/server/api.js